module.exports = __webpack_public_path__ + "banner.ff88e8aa.png";